// plugins/websocket.js
import WebSocketService from '@/utils/webSocket';

const WebSocketPlugin = {
    install(Vue, options = {}) {
        console.log(options);

        // 全局混入
        Vue.mixin({
            created() {
                if (this.$options.websocket) {
                    this.$ws = WebSocketService;

                    // 注册事件监听器
                    const handlers = this.$options.websocket;
                    Object.keys(handlers).forEach((event) => {
                        this.$ws.on(event, handlers[event].bind(this));
                    });
                }
            },

            beforeDestroy() {
                if (this.$ws) {
                    // 移除事件监听器
                    const handlers = this.$options.websocket;
                    if (handlers) {
                        Object.keys(handlers).forEach((event) => {
                            this.$ws.off(event, handlers[event]);
                        });
                    }
                }
            },
        });

        // 添加实例属性
        Vue.prototype.$ws = WebSocketService;

        // 添加全局方法
        Vue.$ws = WebSocketService;
    },
};

export default WebSocketPlugin;
